import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Grid, Tabs, Tab, CssBaseline, Container, AppBar, Grow, Divider, Badge, Tooltip } from '@mui/material/';
import { Stack, Button } from '@mui/material';
import { Navigate, Link } from "react-router-dom";
import { Home, ShoppingCart, IdBadge2, Users, BuildingFactory2, BrandAmongus, Files, Archive, FileDollar, Forklift } from 'tabler-icons-react';
import { query, TokenData } from '../App';

const StyledButton = (props) => <Button {...props} sx={{
    '&.MuiButtonBase-root': {
        padding: '0px',
    },
}} />
function MenuBadge(props) {
    const userPermissions = (React.useContext(TokenData)).permissions;
    return (
        <Badge badgeContent={props.leftDown} color="error" invisible={!userPermissions.admin}
            sx={{ "& .MuiBadge-badge": { padding: 0, height: 15, minWidth: 15 } }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}>
            <Badge badgeContent={props.rightUp} color="success"
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }} >
                <Badge badgeContent={props.leftUp} color="warning"
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }} >
                    {props.children}
                </Badge>
            </Badge>
        </Badge>
    )
}


export default function MenuBar(props) {
    const [filesBadgeData, setFilesBadgeData] = React.useState({ "tocheck": 0, "rejected": 0, "checked": 0 });
    const [invoicesBadgeData, setInvoicesBadgeData] = React.useState({ "emptyInvoices": 0, "packedProducts": 0 });
    console.log(invoicesBadgeData)
    const FilesBadge = (props) => <MenuBadge leftDown={filesBadgeData.rejected} leftUp={filesBadgeData.tocheck} {...props} />
    const ProductionBadge = (props) => <MenuBadge rightUp={filesBadgeData.checked} {...props} />
    const IvoicesBadge = (props) => <MenuBadge leftUp={invoicesBadgeData.emptyInvoices} rightUp={invoicesBadgeData.packedProducts} {...props} />
    const userPermissions = (React.useContext(TokenData)).permissions;

    const filesQuery = async function () {
        if (userPermissions.files.read) {
            const res = await query('/orders/products/files/badges', 'GET', undefined, false)
            setFilesBadgeData(res);
        }
    }

    const invoicesQuery = async function () {
        if (userPermissions.orders.read) {
            const res2 = await query('/orders/products/invoices/badges', 'GET', undefined, false)
            console.log(res2)
            setInvoicesBadgeData(res2);
        }
    }

    let items = [
        { link: '/', icon: Home, label: 'Strona główna' },
        { link: '/orders', icon: ShoppingCart, label: 'Zamowienia', permission: { group: "orders", name: "read" } },
        {
            link: '/orders/files', icon: Files, label: 'Pliki sprawdzanie',
            badge: FilesBadge,
            onClick: filesQuery,
            permission: { group: "files", name: "read" }
        },
        {
            link: '/production', icon: BuildingFactory2, label: 'Produkcja',
            badge: ProductionBadge,
            onClick: filesQuery,
            permission: { group: "production", name: "read" }
        },
        {
            link: '/invoices', icon: FileDollar, label: 'Faktury',
            badge: IvoicesBadge,
            onClick: invoicesQuery,
            permission: { group: "orders", name: "read" }
        },
        { link: '/warehouse', icon: Forklift, label: 'Magazyn', permission: { group: "warehouse", name: "read" } },
        { link: '/archive', icon: Archive, label: 'Archiwum', permission: { group: "archive", name: "read" } },
        { link: '/traders', icon: BrandAmongus, label: 'Handlowcy', permission: { group: "traders", name: "read" } },
        { link: '/clients', icon: IdBadge2, label: 'Klienci', permission: { group: "clients", name: "read" } },
        { link: '/users', icon: Users, label: 'Uzytkownicy', permission: { group: "users", name: "read" } },
    ]



    React.useEffect(() => {
        const req = async () => {
            filesQuery();
            invoicesQuery();
        }
        req();
        const intervalId = setInterval(async () => {
            req();
        }, 1800000);

        return () => {
            clearInterval(intervalId);
        }
    }, []);

    if (userPermissions === undefined) localStorage.clear();
    return (<menu>
        {
            items.map((e, index) => {
                if (!e.permission || (userPermissions[e.permission.group] && userPermissions[e.permission.group][e.permission.name]) || userPermissions.admin)
                    return <React.Fragment key={`menuItem.${e.link}`}>
                        <MenuItem link={e.link} icon={e.icon} label={e.label} badge={e.badge} onClick={e.onClick} />
                        {index != items.length - 1 && <Divider orientation="vertical" variant="middle" flexItem />}
                    </React.Fragment>
            })
        }
    </menu >)
}
const MenuItem = React.forwardRef((props, ref) => (
    <StyledButton component={Link} to={props.link} onClick={props.onClick}>
        <Tooltip title={props.label} enterDelay={500} enterNextDelay={500} placement="bottom">
            <div className="menu-buttonIconContainer">
                {
                    props.badge ? <props.badge><props.icon /></props.badge>
                        : <props.icon />
                }
            </div>
        </Tooltip>
    </StyledButton >
));